import { render, staticRenderFns } from "./CaileFerate.vue?vue&type=template&id=0b507422&"
import script from "./CaileFerate.vue?vue&type=script&lang=js&"
export * from "./CaileFerate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports